module.exports = __webpack_public_path__ + "static/media/Allysia.8dc53d2f.png";